import React, {useState} from 'react';
import style from '../task-creator.module.css'
import ContextMenu from "./ContextMenu";

const TextArea = ({value='',placeholder,changeHandler,className=style.task_input,id='', type=null}) => {
    const [context, setContext] = useState(<></>)
    const close = () => {
        setContext(<></>)
    }
    const clickHandler = (e) => {
        e.preventDefault();
        setContext(<ContextMenu close={close}
                                changeText={changeHandler}
                                element={e}
                                type ={type} />)
    }
    return (
        <>
            <textarea id={id} className={className} value={value}
                      placeholder={placeholder}
                      onChange={e => changeHandler(e)} onContextMenu={e => clickHandler(e)}/>
            {context}
        </>
    );
};

export default TextArea;